import Dictionary from '../dictionary';
import DictionaryFactory from '../dictionary-factory';
import OrganizationServer from "@/api/organization";


export const DICTIONARY_FACTORY_ORG_PERSON = 'org_person';
export const DICTIONARY_FACTORY_ORG_PERSON_TYPE_VALID = 'VALID';
export const DICTIONARY_FACTORY_ORG_PERSON_TYPE_NOT_QUIT = 'NOT_QUIT';
export const DICTIONARY_FACTORY_ORG_PERSON_TYPE_ALL = 'ALL';
export default class OrgPersonDictionaryFactory extends DictionaryFactory {
    constructor() {
        super({name: DICTIONARY_FACTORY_ORG_PERSON});
    }

    async getDictionary({type}) {
        let dictionary;
        switch (type) {
            case DICTIONARY_FACTORY_ORG_PERSON_TYPE_VALID: {
                let persons = [];
                let response = await OrganizationServer.person.list({status: '1'});
                if (response.data.code === '200') {
                    persons = response.data.data;
                }
                dictionary = new Dictionary({items: persons, valueKey: 'id', textKey: 'name'});
                break;
            }
            case DICTIONARY_FACTORY_ORG_PERSON_TYPE_NOT_QUIT: {
                let persons = [];
                let response = await OrganizationServer.person.list({status: '1', types: ['INTERNS', 'ONTRIAL', 'ONJOB']});
                if (response.data.code === '200') {
                    persons = response.data.data;
                }
                dictionary = new Dictionary({items: persons, valueKey: 'id', textKey: 'name'});
                break;
            }
            case DICTIONARY_FACTORY_ORG_PERSON_TYPE_ALL: {
                let persons = [];
                let response = await OrganizationServer.person.list({});
                if (response.data.code === '200') {
                    persons = response.data.data;
                }
                dictionary = new Dictionary({items: persons, valueKey: 'id', textKey: 'name'});
                break;
            }
        }
        if (dictionary == null) {
            dictionary = new Dictionary({items: []});
        }
        return dictionary;
    }
}